function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 32C24.9 32 32 24.9 32 16C32 7.1 24.9 0 16 0C7.1 0 0 7.1 0 16C0 24.9 7.1 32 16 32Z",
  fill: "#2775CA"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4 18.5C20.4 16.2 19 15.4 16.2 15C14.2 14.7 13.8 14.2 13.8 13.3C13.8 12.4 14.5 11.8 15.8 11.8C17 11.8 17.7 12.2 18 13.2C18.1 13.4 18.3 13.5 18.5 13.5H19.6C19.9 13.5 20.1 13.3 20.1 13V13C19.8 11.5 18.6 10.4 17.1 10.3V8.69995C17.1 8.39995 16.9 8.19995 16.6 8.19995H15.6C15.3 8.19995 15.1 8.39995 15.1 8.69995V10.2C13.1 10.5 11.8 11.8 11.8 13.5C11.8 15.7 13.1 16.6 15.9 16.9C17.8 17.2 18.4 17.6 18.4 18.7C18.4 19.8 17.5 20.5 16.2 20.5C14.5 20.5 13.9 19.8 13.7 18.8C13.6 18.5 13.4 18.4 13.2 18.4H12.1C11.8 18.4 11.6 18.6 11.6 18.9V19C11.9 20.7 12.9 21.9 15.1 22.2V23.8C15.1 24.1 15.3 24.2999 15.6 24.2999H16.6C16.9 24.2999 17.1 24.1 17.1 23.8V22.2C19.1 21.7 20.4 20.3 20.4 18.5Z",
  fill: "white"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.70001 12.7001C4.80001 17.8001 7.40001 23.6001 12.6 25.5001C12.8 25.6001 13 25.9001 13 26.1001V27.0001C13 27.1001 13 27.2001 12.9 27.3001C12.8 27.6001 12.6 27.7001 12.3 27.6001C8.60001 26.4001 5.70001 23.5001 4.50001 19.8001C2.50001 13.5001 6.00001 6.7001 12.3 4.7001C12.4 4.6001 12.5 4.6001 12.6 4.6001C12.9 4.7001 13 4.9001 13 5.2001V6.1001C13 6.4001 12.9 6.6001 12.6 6.8001C9.90001 7.8001 7.70001 9.9001 6.70001 12.7001ZM19.1 5.0001C19.2 4.7001 19.4 4.6001 19.7 4.7001C23.4 5.9001 26.3 8.8001 27.5 12.6001C29.5 18.9001 26 25.7001 19.7 27.7001C19.6 27.8001 19.5 27.8001 19.4 27.8001C19.1 27.7001 19 27.5001 19 27.3001V26.4001C19 26.1001 19.1 25.9001 19.4 25.7001C22.1 24.7001 24.3 22.6001 25.3 19.8001C27.2 14.7001 24.6 8.9001 19.4 7.0001C19.2 6.7001 19 6.5001 19 6.2001V5.3001C19 5.1001 19 5.1001 19.1 5.0001Z",
  fill: "white"
});
function SvgTokenUsdc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenUsdc);
export default __webpack_public_path__ + "static/media/token-usdc.1265f2dd2d880f36d4632ce49099ddb9.svg";
export { ForwardRef as ReactComponent };